import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../../../../../../../Common/LoadingButton';
import StyledBox from './styles';

interface NoSummaryProps {
  generateReport(): void;
  loading: boolean;
}

export default function NoSummary(props: NoSummaryProps) {
  const { generateReport, loading } = props;
  const { t } = useTranslation();

  return (
    <StyledBox>
      <Typography variant="body2">
        {t('decisionTree.tree.results.details.summary.no-data')}
      </Typography>
      <LoadingButton
        variant="outlined"
        color="primary"
        loading={loading}
        onClick={() => { generateReport(); }}
      >
        {t('decisionTree.tree.results.report')}
      </LoadingButton>
    </StyledBox>
  );
}
